export default {"src":"/_next/static/media/pos_receipt_original.b349c4af.svg","height":380,"width":510,"blurWidth":0,"blurHeight":0};